import translations from './translations'

translations.add('is', {
    allPaymentsSecure: 'Allar greiðslur tryggðar með',
    poweredBy: 'Knúið af'
})
